import React from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'

const initialState = {
    list: []
}

export default class Documentos extends React.Component {
    constructor(props) {
        super(props)
        this.state = { ...initialState, total: [] }
    }

    componentDidMount() {
        const id = this.props.match.params.id
        const url = `/api/ficha/processo/${id}`
        axios(url)
            .then(resp => {
                this.setState({ list: resp.data })
                this.state.total.push(...this.state.list.documentos)
                this.state.total.push(...this.state.list.despachos)
                this.state.total.push(...this.state.list.anexos)
                this.state.total.push(...this.state.list.certidoes)
                const total = this.state.total.sort((a, b) => {
                    return new Date(a.createdAt) - new Date(b.createdAt)
                })
                this.setState({ total })
            })
            .catch(error => {
                alert(error)
            }
            )
    }

    redirect(url) {
        window.open(url, '_blank')
    }

    excluir(id, tipo, excluir) {
        const idProcesso = this.props.match.params.id
        const url = `/api/processo/excluir/${idProcesso}`
        let ficha = { id, tipo, excluir }
        axios.post(url, ficha)
            .then(res => {
                alert(res.data)
                window.location = `/documentos/${idProcesso}`
            })
            .catch(error => {
                alert(error.response.data)
            })
    }

    ocultar(ficha, despacho) {
        const id = this.props.match.params.id
        if(despacho) {
            var doc = {ficha, despacho}
        } else {
            var doc = {ficha}
        }
        const url = `/api/processo/ocultar/${id}`
        axios.post(url, doc)
            .then(res => {
                window.location = `/documentos/${this.props.match.params.id}`
            })
            .catch(error => {
                alert(error.response.data)
            })
    }

    render() {
        if (this.state.list.data) {
            let ano = this.state.list.data.slice(0, 4)
            let mes = this.state.list.data.slice(5, 7)
            let dia = this.state.list.data.slice(8, 10)
            var data = dia + "/" + mes + "/" + ano
        }
        return (
            <div className="container mx-auto">
                <label className="col-12 mt-5 text-left"><b>{this.state.list.numero}: {this.state.list.estabelecimento}</b></label>
                <div className="text-center mx-auto">
                    <table className="table mt-4">
                        <thead>
                            <tr>
                                <th>USUÁRIO</th>
                                <th>TIPO</th>
                                <th>DATA</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <td>{this.state.list.nome}</td>
                            <td>Capa do Processo</td>
                            <td>{data}</td>
                            <td>
                                <Link to={`/processoCapa/${this.state.list._id}`} target="_blank">
                                    <button className="btn btn-warning">Abrir</button>
                                </Link>
                                <Link to={`/capaEdicao/${this.state.list._id}`} target="_blank">
                                    <button className="btn btn-success ml-2">Editar</button>
                                </Link>
                            </td>
                            {this.renderTotal()}
                        </tbody>
                    </table>
                </div>
                <Link to={`/fiscalizacao/${this.state.list._id}`}>
                    <button className="btn btn-success">Novo Termo de Visita</button>
                </Link>
                <Link to={`/despacho/${this.state.list._id}`}>
                    <button className="btn btn-success ml-3">Novo Despacho</button>
                </Link>
                <Link to={`/certidao/${this.state.list._id}`}>
                    <button className="btn btn-success ml-3">Nova Certidão</button>
                </Link>
                <Link to={`/anexo/${this.state.list._id}`}>
                    <button className="btn btn-success ml-3">Novo Anexo</button>
                </Link>
                <Link to={`/ai/${this.state.list._id}`}>
                    <button className="btn btn-success ml-3">Novo Auto de Infração</button>
                </Link>
                <Link to={`/imprimirProcesso/${this.state.list._id}`} target="_blank">
                    <button className="btn btn-primary ml-3">Imprimir Processo</button>
                </Link>
            </div>
        )
    }

    renderTotal() {
        if (this.state.total) {
            return this.state.total.map(ficha => {
                let ano = ficha.createdAt.slice(0, 4)
                let mes = ficha.createdAt.slice(5, 7)
                let dia = ficha.createdAt.slice(8, 10)
                let data = dia + "/" + mes + "/" + ano
                if (ficha.url) {
                    return (
                        <tr key={ficha.id}>
                            <td>{ficha.user}</td>
                            <td>Anexo - {ficha.name}</td>
                            <td>{data}</td>
                            <td>
                                <button className="btn btn-warning" onClick={e => this.redirect(ficha.url)}>Abrir</button>
                                {this.botaoExcluir(ficha._id, "anexo")}
                            </td>
                        </tr>
                    )
                }
                else if (ficha.certidao) {
                    if (ficha.oculto == "sim") { 
                        return null
                    } else {
                        return (
                            <tr key={ficha.id}>
                                <td>{ficha.user}</td>
                                <td>Certidão</td>
                                <td>{data}</td>
                                <td>
                                    <Link to={`/certidaoView/${ficha._id}`} target="_blank" params={ficha}>
                                        <button className="btn btn-warning">Abrir</button>
                                    </Link>
                                    <button className="btn btn-danger ml-2" onClick={e => this.ocultar(ficha._id, "certidao")}>Ocultar</button>
                                    {this.botaoExcluir(ficha._id, "certidao")}
                                </td>
                            </tr>
                        )
                    }
                }
                else if (ficha.fonte) {
                    if(ficha.oculto == "sim") {
                        return null
                    } else {
                        return (
                            <tr key={ficha.id}>
                                <td>{ficha.user}</td>
                                <td>Despacho</td>
                                <td>{data}</td>
                                <td>
                                    <Link to={`/despachoView/${ficha._id}`} target="_blank" params={ficha}>
                                        <button className="btn btn-warning">Abrir</button>
                                    </Link>
                                    <button className="btn btn-danger ml-2" onClick={e => this.ocultar(ficha._id, "despacho")}>Ocultar</button>
                                    {this.botaoExcluir(ficha._id, "despacho")}
                                </td>
                            </tr>
                        )
                    }
                }
                else {
                    if(ficha.oculto == "sim") {
                        return null
                    }
                    else if (ficha.tipo == "Debito" || ficha.tipo == "Branco") {
                        var tipo = "aiView"
                        return (
                            <tr key={ficha.id}>
                                <td>{ficha.funcionario}</td>
                                <td>A.I - {ficha.tipo}</td>
                                <td>{data}</td>
                                <td>
                                    <Link to={`/${tipo}/${ficha.id}`} target="_blank" params={ficha}>
                                        <button className="btn btn-warning">Abrir</button>
                                    </Link>
                                        <button className="btn btn-danger ml-2" onClick={e => this.ocultar(ficha.id)}>Ocultar</button>
                                        {this.botaoExcluir(ficha.id, "ai")}
                                </td>
                            </tr>
                        )
                    } else {
                        if (ficha.tipo == "Consultório T.O") {
                            var tipo = "toView"
                            var edit = "consultorioTOEdit"
                        } else if (ficha.tipo == "Consultório Fisioterapia") {
                            var tipo = "fisioView"
                            var edit = "consultorioFisioEdit"
                        } else if (ficha.tipo == "Fechado") {
                            var tipo = "fechadoView"
                            var edit = "fechadoEdit"
                        } else if (ficha.tipo == "CAPS Fisioterapia") {
                            var tipo = "capsFisioView"
                            var edit = "capsFisioEdit"
                        } else if (ficha.tipo == "CAPS T.O") {
                            var tipo = "capsTOView"
                            var edit = "capsTOEdit"
                        } else if (ficha.tipo == "Clínica Fisioterapia") {
                            var tipo = "clinicaFisioView"
                            var edit = "clinicaFisioEdit"
                        } else if (ficha.tipo == "Clínica T.O") {
                            var tipo = "clinicaTOView"
                            var edit = "clinicaTOEdit"
                        } else if (ficha.tipo == "CER T.O") {
                            var tipo = "cerTOView"
                            var edit = "cerTOEdit"
                        } else if (ficha.tipo == "Nasf Fisioterapia") {
                            var tipo = "nasfFisioView"
                            var edit = "nasfFisioEdit"
                        } else if (ficha.tipo == "Nasf T.O") {
                            var tipo = "nasfTOView"
                            var edit = "nasfTOEdit"
                        } else if (ficha.tipo == "Ilegal") {
                            var tipo = "ilegalView"
                            var edit = "ilegalEdit"
                        } else if (ficha.tipo == "Rede Social") {
                            var tipo = "socialView"
                            var edit = "socialEdit"
                        } else if (ficha.tipo == "Ilpi Fisioterapia") {
                            var tipo = "ilpiFisioView"
                            var edit = "ilpiFisioEdit"
                        } else if (ficha.tipo == "Ilpi T.O") {
                            var tipo = "ilpiTOView"
                            var edit = "ilpiTOEdit"
                        } else if (ficha.tipo == "Hospital Fisioterapia") {
                            var tipo = "hospitalFisioView"
                            var edit = "hospitalFisioEdit"
                        } else if (ficha.tipo == "Hospital T.O") {
                            var tipo = "hospitalTOView"
                            var edit = "hospitalTOEdit"
                        } else if (ficha.tipo == "Branco TV") {
                            var tipo = "brancoView"
                            var edit = "brancoEdit"
                        }

                        let processo = this.props.match.params.id
                        return (
                            <tr key={ficha.id}>
                                <td>{ficha.funcionario}</td>
                                <td>TV - {ficha.tipo}</td>
                                <td>{data}</td>
                                <td>
                                    <Link to={`/${tipo}/${ficha.id}`} target="_blank" params={ficha}>
                                        <button className="btn btn-warning">Abrir</button>
                                    </Link>
                                    <Link to={{
                                        pathname: `/${edit}/${ficha.id}`,
                                        search: `${processo}`
                                        }} 
                                        target="_blank" params={ficha}>
                                        <button className="btn btn-success ml-2">Editar</button>
                                    </Link>
                                    <button className="btn btn-danger ml-2" onClick={e => this.ocultar(ficha.id)}>Ocultar</button>
                                    {this.botaoExcluir(ficha.id, "tv", ficha.tipo)}
                                </td>
                            </tr>
                        )
                    }
                }
            })
        }
    }

    botaoExcluir(id, tipo, excluir) {
        if (localStorage.tipo == "interno") {
            return <button className="btn btn-dark ml-2" onClick={e => this.excluir(id, tipo, excluir)}>Excluir</button>
        } else {
            return null
        }
    }
}